<template>
    <v-container fluid class="pt-0">
        <v-card class="px-5 py-3 br-15 w-100" elevation="0">
            <v-row>
                <v-col class="flex-grow-1">
                    <v-toolbar-title class="page-title"
                        >Importação base fornecedor</v-toolbar-title
                    >
                </v-col>

            </v-row>
        </v-card>

        <v-card class="px-5 my-5 py-3 br-15 w-100" elevation="0">
            <v-card-text>
                <div class="instrucoes">
                    <h4 color="primary">
                        Para realizar a importação de planejamentos, siga as
                        instruções abaixo.
                    </h4>
                    <ul>
                        <li>
                            A base utilizada para importação deve ser parecido
                            ao modelo de exportação. Todas as linhas importadas
                            serão consideradas para
                            <strong>Inserção.</strong>
                        </li>

                        <li>
                            As seguintes colunas são obrigatórias:
                            <ul>
                                <li>
                                    <strong>bandeira</strong> - RAIA ou DROGASIL
                                </li>
                                <li>
                                    <strong>data_inicio</strong> - Data de
                                    início da ativação no formato
                                    <strong>(DD/MM/AAAA)</strong>
                                </li>
                                <li>
                                    <strong>data_fim</strong> - Data de fim da
                                    ativação no formato
                                    <strong>(DD/MM/AAAA)</strong>
                                </li>
                                <li>
                                    <strong>ativacao</strong> - Nome da ativação
                                    conforme foi cadastrado, minusculo, sem
                                    acentos e sem espaços.
                                </li>
                                <li>
                                    <strong>devices</strong> - Devices separados
                                    por traço (desktop-mobile-app).
                                </li>
                                <li>
                                    <strong>id_categoira</strong> - Id da
                                    categoria conforme foi cadastrada.
                                </li>
                                <li>
                                    <strong>area</strong> - Nome da área
                                    conforme foi cadastrado
                                </li>
                                <li>
                                    <strong>id_marca</strong> - Id da marca
                                    conforme planilha de produto x fornecedor
                                </li>
                            </ul>
                        </li>
                        <li>
                            Para indicar um fornecedor, deve ser utilizado o
                            Código do fornecedor na coluna
                            <strong>codigo_fornecedor</strong>. A coluna
                            <strong>fornecedor</strong> é para simples
                            conferência.
                        </li>
                        <li>
                            Em caso de erro de validação ou falta de
                            disponibilidade, o sistema irá desconsiderar a linha
                            em questão e seguir com o processo de importação.
                        </li>
                    </ul>
                </div>

                <v-row>
                    <v-col>
                        <v-alert
                            v-if="erroImportacao"
                            type="error"
                            text
                            icon="mdi-close-circle"
                            class="justify-center"
                        >
                            <v-row align="center">
                                <v-col class="grow py-0"> {{ errosMensagem }}</v-col>
                                <v-col class="shrink py-0">
                                    <v-btn
                                        v-if="errosImportacao"
                                        color="red"
                                        @click="dialogErro = true"
                                        small
                                        style="font-size: 16px; font-weight: 500"
                                        >Exibir erros</v-btn
                                    >
                                </v-col>
                            </v-row>
                        </v-alert>
                        <v-alert
                            v-if="sucessos.length > 0"
                            type="success"
                            text
                            icon="mdi-check-circle"
                            class="justify-center"
                        >
                            <v-row align="center">
                                <v-col class="grow py-0"
                                    >As demais linhas foram inseridas com sucesso. Total de
                                    linhas inseridas: {{ sucessos.length }}</v-col
                                >
                            </v-row>
                        </v-alert>
                    </v-col>
                </v-row>

                <v-form ref="fromInventario">
                    <v-row class="mt-5">
                        <v-col cols="12" class="pb-0">
                            <v-file-input
                                label="Arquivo XLSX"
                                class="input-cinza"
                                outlined
                                dense
                                v-model="arquivoXLSX"
                                accept=".xlsx"
                                :rules="regra.xlsx"
                            ></v-file-input>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    class="new-button px-6 mb-3 mr-2"
                    @click="importar()"
                >
                    <v-icon left>mdi-upload</v-icon>
                    Importar Arquivo
                </v-btn>
            </v-card-actions>
        </v-card>

        <v-dialog
            content-class="br-15"
            v-model="dialogErro"
            width="800"
            :z-index="400"
        >
            <v-card>
                <v-toolbar elevation="0" dark class="error white--text fix-flex">
                    <v-toolbar-title> Erros durante a importação </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                        fab
                        width="24px"
                        height="24px"
                        elevation="0"
                        light
                        @click="dialogErro = false"
                    >
                        <v-icon size="18px" color="error">mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="mt-4">
                    <v-data-table
                        :headers="headerErros"
                        class="elevation-0 tabela"
                        :items="errosImportacao"
                        :items-per-page="10"
                        :footer-props="tableConfig"
                        color="error"
                    ></v-data-table>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <download-csv
                        :data="errosImportacao"
                        :labels="errosLabels"
                        name="erros_planejamento_fornecedor.csv"
                        delimiter=";"
                    >
                        <v-btn class="new-button px-4 mb-2" color="primary">
                            <v-icon class="mr-3">mdi-microsoft-excel</v-icon>
                            Exportar erros em CSV
                        </v-btn>
                    </download-csv>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            content-class="br-15"
            v-model="dialogConfirmacaoAnoAnterior"
            width="700"
            persistent
            :z-index="450"
        >
            <v-card>
                <v-toolbar
                    elevation="0"
                    dark
                    class="primary-degrade white--text fix-flex"
                >
                    <v-toolbar-title>Confirmação de Importação</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                        fab
                        width="24px"
                        height="24px"
                        elevation="0"
                        light
                        @click="dialogConfirmacaoAnoAnterior = false"
                    >
                        <v-icon size="18px" color="primary">mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>

                <v-card-text class="mt-4 px-5">
                    <v-alert colored-border>
                        <strong>Orientação:</strong>
                        {{ mensagemConfirmacaoAnoAnterior }}
                    </v-alert>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        class="new-button px-6 mb-2 mr-2"
                        color="primary"
                        @click="dialogConfirmacaoAnoAnterior = false"
                    >
                        <v-icon left>mdi-check-circle</v-icon>
                        Confirmar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-overlay :value="carregando" :z-index="300">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
</template>

<script>
import useFiltros from '@/hooks/useFiltros'
import XLSX from 'xlsx'
export default {
    name: 'exportacao modelo',
    setup() {
        const { isLoading, isError, isFetching, data, error, refetch } =
            useFiltros('/planejamentoEcommerce/listaCampos')
        return {
            isLoading,
            isError,
            isFetching,
            lista: data,
            error,
            refetch,
        }
    },
    data() {
        return {
            formValido: false,

            menuProps: {
                bottom: true,
                offsetY: true,
                contentClass: 'select-outline',
                transition: 'slide-y-transition',
            },

            carregando: false,

            dialogErro: false,
            dialogConfirmacaoAnoAnterior: false,
            mensagemConfirmacaoAnoAnterior:
                'Você está fazendo uma importação de um planejamento do ano anterior.',
            sucessos: [],
            erroImportacao: false,
            errosImportacao: [],
            errosMensagem: '',
            headerErros: [
                { text: 'Descrição', value: 'msg', class: 'th-separador' },
                { text: 'Linha', value: 'linha', align: 'center', with: '100px' },
            ],
            errosLabels: {
                msg: 'Descrição',
                linha: 'Linha',
            },
            tableConfig: {
                itemsPerPageOptions: [10, 15, 25, 50, 100],
                itemsPerPageText: 'Linhas por páginas',
                ofText: 'de',
                pageText: '{0}-{1} de {2}',
            },

            regra: {
                xlsx: [(v) => !!v || 'Arquivo XLSX é obrigatório'],
            },
            arquivoXLSX: null,
        }
    },

    created() {
        // this.filtrar()
    },
    computed: {
        extension() {
            return this.file
                ? this.file.name.split('.').pop().toLowerCase()
                : ''
        },
    },
    methods: {
        async importar() {
            if (!this.$refs.fromInventario.validate()) return

            // Resetar variáveis de erro
            this.erroImportacao = false
            this.errosImportacao = []
            this.sucessos = []
            this.errosMensagem = ''

            this.carregando = true

            var formData = new FormData()

            formData.append('files', this.arquivoXLSX)

            var response = await this.$http().post(
                '/planejamentoEcommerce/planejamentoFornecedor/importar',
                formData
            )

            const alertaAnoAnterior =
                response?.data?.alertaAnoAnterior ||
                response?.alertaAnoAnterior ||
                null
            this.carregando = false

            if (response.status == 200 && response.data.error == false) {
                const deveExibirPopup =
                    this.deveExibirPopupAnoAnterior(alertaAnoAnterior) ||
                    (await this.deveExibirPopupAnoAnteriorPorArquivo(alertaAnoAnterior))

                if (deveExibirPopup) {
                    this.abrirPopupAnoAnterior(alertaAnoAnterior?.mensagem)
                }

                this.$dialog.notify.success(
                    'Planejamento importado com sucesso'
                )

                this.arquivoXLSX = null
                this.$refs.fromInventario.reset()
            } else {
                this.erroImportacao = true
                this.errosImportacao = response.data?.erros || []
                this.sucessos = response.data?.sucessos || []
                this.errosMensagem =
                    response.data.mensagem || 'Erro ao importar planejamento'
            }
        },
        deveExibirPopupAnoAnterior(alertaAnoAnterior) {
            const valor = alertaAnoAnterior?.exibir

            if (typeof valor === 'boolean') {
                return valor
            }

            if (typeof valor === 'number') {
                return valor === 1
            }

            if (typeof valor === 'string') {
                return ['true', '1', 'sim'].includes(valor.toLowerCase())
            }

            return false
        },
        async deveExibirPopupAnoAnteriorPorArquivo(alertaAnoAnterior) {
            if (this.deveExibirPopupAnoAnterior(alertaAnoAnterior)) {
                return false
            }

            if (!this.arquivoXLSX) {
                return false
            }

            try {
                const dados = await this.lerArquivoArrayBuffer(this.arquivoXLSX)
                const workbook = XLSX.read(dados, { type: 'array', cellDates: true })
                const anos = this.extrairAnosWorkbook(workbook)
                const anoVigente = this.$moment().year()

                return anos.some((ano) => ano < anoVigente)
            } catch (error) {
                return false
            }
        },
        lerArquivoArrayBuffer(arquivo) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.onload = () => resolve(reader.result)
                reader.onerror = reject
                reader.readAsArrayBuffer(arquivo)
            })
        },
        extrairAnosWorkbook(workbook) {
            const anos = new Set()

            workbook.SheetNames.forEach((sheetName) => {
                const sheet = workbook.Sheets[sheetName]
                const linhas = XLSX.utils.sheet_to_json(sheet, {
                    header: 1,
                    raw: true,
                    defval: null,
                })

                if (!linhas.length) {
                    return
                }

                const indiceCabecalho = this.encontrarLinhaCabecalho(linhas)
                if (indiceCabecalho < 0) {
                    return
                }

                const cabecalho = (linhas[indiceCabecalho] || []).map((coluna) =>
                    this.normalizarCabecalho(coluna)
                )
                const indicesData = cabecalho.reduce((acc, coluna, indice) => {
                    if (['data_inicio', 'data_fim'].includes(coluna)) {
                        acc.push(indice)
                    }

                    return acc
                }, [])

                if (!indicesData.length) {
                    return
                }

                linhas.slice(indiceCabecalho + 1).forEach((linha) => {
                    indicesData.forEach((indice) => {
                        const ano = this.extrairAnoDeCelulaData(linha?.[indice])
                        if (Number.isInteger(ano)) {
                            anos.add(ano)
                        }
                    })
                })
            })

            return Array.from(anos)
        },
        encontrarLinhaCabecalho(linhas = []) {
            const limiteBusca = Math.min(linhas.length, 15)

            for (let indice = 0; indice < limiteBusca; indice += 1) {
                const normalizada = (linhas[indice] || []).map((coluna) =>
                    this.normalizarCabecalho(coluna)
                )
                const possuiInicio = normalizada.includes('data_inicio')
                const possuiFim = normalizada.includes('data_fim')

                if (possuiInicio || possuiFim) {
                    return indice
                }
            }

            return -1
        },
        extrairAnoDeCelulaData(celula) {
            if (celula == null || celula === '') {
                return null
            }

            if (celula instanceof Date) {
                return celula.getFullYear()
            }

            if (typeof celula === 'number') {
                if (celula >= 1900 && celula <= 2200) {
                    return Math.trunc(celula)
                }

                const dataExcel = XLSX.SSF.parse_date_code(celula)
                if (dataExcel && Number.isInteger(dataExcel.y)) {
                    return dataExcel.y
                }
            }

            const texto = String(celula).trim()
            const matchDataBr = texto.match(/^\d{1,2}[/-]\d{1,2}[/-](\d{4})$/)
            if (matchDataBr) {
                return Number(matchDataBr[1])
            }

            const matchDataIso = texto.match(/^(\d{4})[/-]\d{1,2}[/-]\d{1,2}$/)
            if (matchDataIso) {
                return Number(matchDataIso[1])
            }

            const matchAno = texto.match(/^(19|20)\d{2}$/)
            if (matchAno) {
                return Number(matchAno[0])
            }

            return null
        },
        normalizarCabecalho(valor = '') {
            return String(valor)
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .trim()
                .toLowerCase()
        },
        abrirPopupAnoAnterior(mensagem) {
            this.mensagemConfirmacaoAnoAnterior =
                mensagem ||
                'Você está fazendo uma importação de um planejamento do ano anterior.'
            this.dialogConfirmacaoAnoAnterior = false
            this.$nextTick(() => {
                this.dialogConfirmacaoAnoAnterior = true
            })
        },
    },
}
</script>
